var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { TextField as MuiTextField, Box, FormControl, FormHelperText, } from "@mui/material";
import { buildFieldValidation } from "../../validators/field-components";
import { useElementConditions } from "../../context/FormLogicContext";
import Header from "../common/Header";
import { getInitialValueForElement } from "../../../../utils/forms-functions";
import { getElementValueKey } from "../../../../utils/helpers";
var NumberField = function (_a) {
    var element = _a.element, errors = _a.errors;
    var unregister = useFormContext().unregister;
    var valueKey = getElementValueKey(element);
    var error = errors[valueKey];
    var _b = useElementConditions(element), isVisible = _b.isVisible, isEnabled = _b.isEnabled, isInteractive = _b.isInteractive, fieldRequired = _b.isRequired;
    var validation = useMemo(function () {
        return buildFieldValidation(element, {
            isRequired: fieldRequired,
            readOnly: !isEnabled,
        });
    }, [element, fieldRequired, isEnabled]);
    var initialValue = getInitialValueForElement(element);
    var _c = useState({
        show: false,
        message: "",
    }), limitMessage = _c[0], setLimitMessage = _c[1];
    useEffect(function () {
        if (!isVisible) {
            unregister(valueKey);
        }
    }, [isVisible, valueKey, unregister]);
    return (_jsx(_Fragment, { children: isVisible ? (_jsx(Box, __assign({ className: "component-wrapper" }, { children: _jsxs(FormControl, __assign({ fullWidth: true, error: !!error, sx: { mb: 3 } }, { children: [_jsx(Header, { element: element, error: !!error, isRequired: fieldRequired }), limitMessage.show && (_jsx(FormHelperText, __assign({ error: true, sx: { mb: 1 } }, { children: limitMessage.message }))), _jsx(Controller, { name: valueKey, defaultValue: initialValue, rules: {
                            validate: function (value) {
                                var _a;
                                var result = validation.safeParse(value);
                                if (!result.success) {
                                    return ((_a = result.error.errors[0]) === null || _a === void 0 ? void 0 : _a.message) || "Valor inválido";
                                }
                                return true;
                            },
                        }, render: function (_a) {
                            var field = _a.field;
                            return (_jsx(MuiTextField, __assign({}, field, { fullWidth: true, type: "number", placeholder: element.placeholder, error: !!error, helperText: error === null || error === void 0 ? void 0 : error.message, disabled: !isInteractive, inputProps: {
                                    min: element.min || undefined,
                                    max: element.max || undefined,
                                    step: element.step || undefined,
                                }, onChange: function (e) {
                                    setLimitMessage({ show: false, message: "" });
                                    var value = e.target.value;
                                    if (!value) {
                                        field.onChange("");
                                        return;
                                    }
                                    if (element.min &&
                                        Number(value) < element.min) {
                                        setLimitMessage({
                                            show: true,
                                            message: "O valor inserido \u00E9 inferior ao permitido (".concat(element.min, "). Ele foi ajustado automaticamente para o m\u00EDnimo."),
                                        });
                                        field.onChange(Number(element.min));
                                    }
                                    else if (element.max &&
                                        Number(value) > element.max) {
                                        setLimitMessage({
                                            show: true,
                                            message: "O valor inserido \u00E9 superior ao permitido (".concat(element.max, "). Ele foi ajustado automaticamente para o m\u00E1ximo."),
                                        });
                                        field.onChange(Number(element.max));
                                    }
                                    else {
                                        field.onChange(Number(value));
                                    }
                                } })));
                        } })] })) }))) : null }));
};
export default NumberField;
